export const PAYMENT_ROUTES = ['/select-subscription', '/pricing'];

export const isPaymentRoute = (pathname) =>
    PAYMENT_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
